<ng-template #shareUsers let-modal>
  <div class="modal-body">
    <div>
      <button type="button" class="close-x" aria-label="Close" (click)="modal.dismiss('Cross click')" *ngIf="this.shareSending==false">
        <i class="fa-solid fa-xmark"></i>
      </button>
    </div>

    <div class="mt-2 pb-2" *ngIf="this.sharedone===true">
      <div class="row">
        <div class="col text-center">
          <img [src]="shareSuccessIcon">
        </div>
      </div>
      <div class="row">
        <div class="col text-center pt-2">
          <h3>
            Shared Successfully
          </h3>
          <p class="text-primary">
            Your report has been sent successfully!
          </p>
          <p class="pt-3">
            <button class="btn btn-primary" (click)="modal.dismiss('Cross click')" style="min-width: 10rem;">Got
              it</button>
          </p>
        </div>

      </div>
    </div>

    <div *ngIf="this.sharedone===false &&this.shareSending==false">

      <div class="row">
        <div class="col pt-2 text-center">
          <img [src]="shareIcon">

          <h2 class="pt-3 black">
            Share this report
          </h2>
          <p class="text-primary text-center">
            To share with multiple users, press enter after each email address captured or simply use a ';'.
          </p>
        </div>
      </div>

      <form [formGroup]="shareToForm">

        <div class="row">
          <div class="col">
            <div class="border border-light-subtle rounded position-relative p-2 pt-0">
              <button class="btn btn-sm position-absolute top-0 end-0 fs-3 mt-2 me-3 text-primary"
                (click)="addEmail()">+</button>
              <div class="row">
                <div class="col">
                  <label class="text-capitalize" for="mailTo">Email</label>
                </div>
              </div>
              <div class="row">
                <div class="col p-0" style="max-height: 140px; overflow-y: auto;">
                  <div class="badge badge-light m-1 text-lowercase fw-normal text-primary"
                    *ngFor="let eml of emailList">
                    {{ eml }}&nbsp;&nbsp;&nbsp;<a href="javascript:void(0);" class="text-dark"
                      (click)="remEmail(eml)">X</a>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col p-0">
                  <input formControlName="mailTo" type="text" class="form-control border-0" #mailTo
                    aria-describedby="mailTo" placholder="Email">

                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col">
            <div class="form-group">

              <textarea formControlName="message" class="form-control">

                </textarea>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col text-center">
            <button type="button" class="btn btn-primary" (click)="shareReport()" *ngIf="this.shareSending==false">Share
              Report</button>
          </div>
        </div>

        <div class="alert alert-danger text-center mt-2" *ngIf="this.statusmessage!=''">
          {{this.statusmessage}}
        </div>

      </form>

    </div>

    <div class="row" *ngIf="this.shareSending==true">
      <div class="col text-center">
        <img [src]="shareIconSending" class="mb-2">

        <h2>Sending Report</h2>

        <p class="text-primary">
          Your report is on its way! It's being sent now. <br>
          <b>This should only take a moment.</b>

        </p>

      </div>
    </div>
  </div>

</ng-template>